import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AppDispatch } from '../../redux-store'

interface InitialStateTypes {
    language: string,
    update: boolean
}

let initialState: InitialStateTypes = {
    language: 'tm',
    update: true,
}

export const languageSlice = createSlice({
    name: 'language',
    initialState,
    reducers: {
        setUpdate(state, action: PayloadAction<boolean>) {
            state.update = action.payload
        },
        setLanguage(state, action: PayloadAction<string>) {
            state.update = false
            state.language = action.payload
        }
    }
})

export const setUpdate = (update: boolean) => async (dispatch: AppDispatch) => {
    dispatch(languageSlice.actions.setUpdate(update))
}

export const setLanguage = (language: string) => async (dispatch: AppDispatch) => {
    dispatch(languageSlice.actions.setLanguage(language))
}

export default languageSlice.reducer